import { USER_FEEDBACK } from "../APIErrors";
import { LogErrorResponse } from "../Logging/LoggingAPI";
import { BringAddressesResponse, BringAddressesResponseSchema } from "./bringAPISchema";

const API_URL = "/api/address";

export async function getAddresses(
    query: string,
): Promise<BringAddressesResponse | null> {
    const url = `${API_URL}/suggestions?query=${query}`;

    const response = await fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });

    if (!response.ok) {
        return null;
    }

    const data = await response.json();
    const validatedData = BringAddressesResponseSchema.parse(data);

    return validatedData;
}